<template>
  <div v-if="open" class="report_modal_body">
    <LoadingOverlay
        :activeSyncProps="activeSync"
        :isFullPageProps="true"
        :hiddenProps="hidden"
    />
    <div class="header">
      <div class="top-side">
        <img src="https://bucket.rebless.pro/clinic/logo/rebless-clinic-logo.svg"
             class="logo" alt="logo">
        <div class="header-info" style="display: none;">
          <div class="top">
            <span class="key text">{{ $t('report.paper.written_by') }} :</span>
            <span class="value text">&nbsp;{{ this.managerName }}</span>
          </div>
          <div class="bottom">
            <span class="key text">{{ $t('report.paper.published_date') }} :</span>
            <span class="value text">&nbsp;{{ this.moment().locale($t('country')).format('ll') }}</span>
          </div>
        </div>
      </div>
      <div class="bottom-side">
        {{ $t('report.paper.report_title') }}
      </div>
    </div>
    <div class="footer">
      <div>
        <img src="https://bucket.rebless.pro/images/ci/hrobotics-bi-horizontal_150x26_jpg.jpg"
             class="logo" alt="logo" width="130px" style="margin-top: 10px;">
      </div>
    </div>
    <table>
      <thead>
      <tr>
        <th scope="col">
          <div class="t-head"/>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>
          <div class="content">
            <div class="report_row basic_info report_common_table">
              <div class="sub_header">
                {{ $t('report.paper.basic_info') }}
              </div>
              <KvTable :items="calculateBasicInfo"/>
            </div>
            <component :is="sectionComponentList[0]" :rehabilitationItemsProps="rehabilitationItems"
                       :searchDateProps="calculateSearchDate" :romChartDataProps="romChartData"></component>
            <component :is="sectionComponentList[1]" :rehabilitationItemsProps="rehabilitationItems"
                       :searchDateProps="calculateSearchDate" :romChartDataProps="romChartData"></component>
          </div>
        </td>
      </tr>
      </tbody>
      <tfoot>
      <tr>
        <td>
          <div class="t-foot"/>
        </td>
      </tr>
      </tfoot>
    </table>

    <div @click="print()" class="print_btn pointer">
      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
           width="20" height="20"
           viewBox="0 0 172 172"
           style=" fill:#000000; margin: 10px;">
        <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
           stroke-linejoin="miter"
           stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none"
           font-weight="none"
           font-size="none" text-anchor="none" style="mix-blend-mode: normal">
          <path d="M0,172v-172h172v172z" fill="none"></path>
          <g fill="#ffffff">
            <path
                d="M46.10096,0c-10.87921,0 -19.84615,8.96695 -19.84615,19.84615v33.07692h-6.40865c-10.95673,0 -19.84615,8.88942 -19.84615,19.84615v39.69231c0,10.95673 8.88942,19.84615 19.84615,19.84615h6.40865v19.84615c0,10.87921 8.96695,19.84615 19.84615,19.84615h79.38462c10.87921,0 19.84615,-8.96695 19.84615,-19.84615v-19.84615h6.82212c10.95673,0 19.84615,-8.88942 19.84615,-19.84615v-39.69231c0,-10.95673 -8.88942,-19.84615 -19.84615,-19.84615h-6.82212v-33.07692c0,-10.87921 -8.96695,-19.84615 -19.84615,-19.84615zM46.10096,13.23077h79.38462c3.72115,0 6.61538,2.89423 6.61538,6.61538v33.07692h-92.61538v-33.07692c0,-3.72115 2.89423,-6.61538 6.61538,-6.61538zM142.23077,66.15385c5.47837,0 9.92308,4.44471 9.92308,9.92308c0,5.47837 -4.44471,9.92308 -9.92308,9.92308c-5.47837,0 -9.92308,-4.44471 -9.92308,-9.92308c0,-5.47837 4.44471,-9.92308 9.92308,-9.92308zM39.48558,99.23077h92.61538v52.92308c0,3.72115 -2.89423,6.61538 -6.61538,6.61538h-79.38462c-3.72115,0 -6.61538,-2.89423 -6.61538,-6.61538zM52.92308,112.46154v13.23077h66.15385v-13.23077zM52.92308,132.30769v13.23077h46.30769v-13.23077z"></path>
          </g>
        </g>
      </svg>
    </div>
  </div>
</template>
<script>
import KvTable from '@/components/Table/kvTable/index'
import ExpertOpinionSection from "@/components/modal/reportModal/expertOpinionSection"
import RomChangeSection from "@/components/modal/reportModal/romChangeSection";
import LoadingOverlay from '@/components/loadingOverlay'
import {mapGetters} from 'vuex'
import {_BASIC_INFO_TABLE, _REHABILITATION_ITEMS_TEMPLATE, copyStyles} from "@/components/modal/reportModal/lib"
import {GENDER_TRANS, REPORT_SECTION_ITEM} from "@/enum/lib"
import {
  _BRAIN_LESION_RANGE,
} from "@/components/Table/static";
import _API from "@/api"

export default {
  name: 'ReportModal',
  model: {
    prop: 'open',
    event: 'close'
  },
  components: {RomChangeSection, ExpertOpinionSection, KvTable, LoadingOverlay},
  props: ['open', 'patientInfoProps', 'reportPreviewItemsProps'],
  data() {
    return {
      sectionComponentList: [],
      managerName: '',
      windowRef: null,
      romChartData: {
        chartData: {},
        requestData: {}
      },
      isChiefComplainVuexSubscribe: false,
      chiefComplainData: undefined,
      rehabilitationItems: _REHABILITATION_ITEMS_TEMPLATE,
      activeSync: true,
      hidden: '',
    }
  },
  watch: {
    open(newOpen) {
      if (newOpen) {
        this.openPortal();
      } else {
        this.closePortal();
      }
    },
    reportPreviewItemsProps: {
      deep: true,
      handler(newData) {
        this.sectionComponentList.clear()
        for (let data of newData) {
          switch (data?.value) {
            case REPORT_SECTION_ITEM.ROM_MONITORING : {
              this.sectionComponentList.push('RomChangeSection');
              break;
            }
            case REPORT_SECTION_ITEM.CHIEF_COMPLAIN : {
              this.subscribeChiefComplainData()
              break;
            }
            case REPORT_SECTION_ITEM.EXPERT_OPINION : {
              this.sectionComponentList.push('ExpertOpinionSection');
              break;
            }
          }
        }
      }
    }
  },
  methods: {
    ...mapGetters(['getAuth', 'getReport']),
    openPortal() {
      this.getInitAndLastPatientConditionForReport().catch(e => {
        console.log(e);
      });
      this.windowRef = window.open("", "", "width=750, top=0px, left=0px, height=900, channelmode=yes");
      this.windowRef.document.title = this.$t('report.paper.report_title');
      this.windowRef.document.body.appendChild(this.$el);
      copyStyles(window.document, this.windowRef.document);
      this.windowRef.addEventListener('beforeunload', this.closePortal);
      this.windowRef.addEventListener('click', this.handelEvent);
      this.windowRef.addEventListener('mousedown', this.handelEvent);
      this.windowRef.addEventListener('mouseup', this.handelEvent);
      this.windowRef.addEventListener('keyup', this.handelEvent);
      this.windowRef.addEventListener('keydown', this.handelEvent);
      this.windowRef.addEventListener('wheel', this.handelEvent);
    },
    closePortal() {
      if (this.windowRef) {
        this.windowRef.close();
        this.windowRef = null;
      }
      this.$emit('closeReport');
    },
    print() {
      this.windowRef.print();
    },
    async getInitAndLastPatientConditionForReport() {
      this.hidden = '';
      try {
        const {requestData} = this.romChartData;
        if (requestData.startDatetime === undefined || requestData.endDatetime === undefined) return;
        const inputData = {
          seqMedicalRelation: this.patientInfoProps.patientInfo.seqMedicalRelation,
          seqDeviceType: requestData.seqDeviceType,
          position: requestData.position,
          direction: requestData.direction,
          searchDate: {
            start: requestData.startDatetime,
            end: requestData.endDatetime
          }
        }
        const {data} = await _API.REPORT.getInitAndLastPatientConditionForReport(inputData);
        if (data.isSuccess) {
          // 성공 로직
          data.seqDeviceType = inputData.seqDeviceType;
          data.position = inputData.position;
          data.direction = inputData.direction;
          data.searchDate = inputData.searchDate;
          this.rehabilitationItems = data;
        }
      } catch (e) {
        throw new Error(`[getInitAndLastPatientConditionForReport]${e}`);
      } finally {
        this.hidden = 'hidden'
      }
    },
    calculateRomChartDataFromVuex(data) {
      // vuex로부터 가지고온 값을 안전하게 vue.set 하여 저장합니다.
      // 해당 값의 변화를 감지합니다. 물론 현재 상태에서는 변화를 감지할 포인트는 없습니다만.
      this.$set(this.romChartData, 'chartData', data?.chartData ?? {});
      this.$set(this.romChartData, 'requestData', data?.requestData ?? {});
    },
    subscribeChiefComplainData() {
      if (!this.isChiefComplainVuexSubscribe) {
        this.unsubscribeSub = this.$store.subscribe((_mutation, state) => {
          this.chiefComplainData = state.report.chiefComplainData;
        });
        this.isChiefComplainVuexSubscribe = true;
      }
    },
    handelEvent() {
      localStorage.setItem('time', this.moment());
    },
  },
  mounted() {
    const {userName} = this.getAuth();
    this.managerName = userName;
    this.calculateRomChartDataFromVuex(this.getReport().romChartData);
    if (this.open) {
      this.openPortal();
    }
  },
  created() {
    this.unsubscribeMain = this.$store.subscribe((_mutation, state) => {
      this.calculateRomChartDataFromVuex(state.report.romChartData);
    });
  },
  beforeDestroy() {
    if (this.windowRef) {
      this.windowRef.removeEventListener('click', this.handelEvent);
      this.windowRef.removeEventListener('mousedown', this.handelEvent);
      this.windowRef.removeEventListener('mouseup', this.handelEvent);
      this.windowRef.removeEventListener('keyup', this.handelEvent);
      this.windowRef.removeEventListener('keydown', this.handelEvent);
      this.windowRef.removeEventListener('wheel', this.handelEvent);
      this.unsubscribeMain();
      this.unsubscribeSub();
      this.closePortal();
    }
  },
  computed: {
    calculateBasicInfo() {
      const tableInfo = new _BASIC_INFO_TABLE(this);
      const patientInfo = this.patientInfoProps.patientInfo;
      const patientStatus = this.patientInfoProps.patientStatus;
      tableInfo[0].values = patientInfo.patientInfoName;
      const age = patientInfo.patientInfoBirth ? this.$t('unit.man') + ' ' + this.moment().diff(this.moment(patientInfo.patientInfoBirth, 'YYYY-MM'), 'y') + ' ' + this.$t('unit.years_old') : '-'
      tableInfo[1].values = age + '/' + (patientInfo.patientInfoGender ? this.$t(GENDER_TRANS[patientInfo.patientInfoGender].trans) : GENDER_TRANS[null].trans);
      tableInfo[2].values = this.patientInfoProps.patientEmail;
      tableInfo[3].values = this.$t(_BRAIN_LESION_RANGE[patientInfo.patientInfoBrainLesion]?.trans);
      tableInfo[4].values = patientInfo.patientInfoOccurrenceDate ? this.moment(patientInfo.patientInfoOccurrenceDate).locale(this.$t('country')).format('ll') : '-';
      tableInfo[5].values = patientInfo.patientInfoOccurrenceDate ? this.moment().diff(this.moment(patientInfo.patientInfoOccurrenceDate), 'd') + this.$t('unit.days') : '-';
      tableInfo[6].values = patientStatus?.patientStatusParalysisPart ? patientStatus?.patientStatusParalysisPart : '-';
      tableInfo[7].values = patientInfo?.patientInfoPrimaryDiagnosis ? patientInfo?.patientInfoPrimaryDiagnosis : '-';
      tableInfo[8].values = patientInfo?.patientInfoSecondaryDiagnosis ? patientInfo?.patientInfoSecondaryDiagnosis : '-';
      tableInfo[9].values = this?.chiefComplainData ?? '-';
      return tableInfo
    },
    calculateSearchDate() {
      return this.moment(this.rehabilitationItems.searchDate.start).locale(this.$t('country')).format('ll')
          + ' ~ ' + this.moment(this.rehabilitationItems.searchDate.end).locale(this.$t('country')).format('ll')
    }
  },
}
</script>
<style lang="scss">
.report_body {
  min-width: 750px;
  overflow: auto;
}

.report_modal_body {
  padding: 15px;
  background: #fff;

  tbody tr {
    background: #fff;
  }

  tbody tr:hover {
    background: none;
  }
}

.header {
  height: 90px;
  width: calc(100vw - 50px);
  min-width: 765px;
  position: fixed;
  top: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid var(--white);
  z-index: 1;

  .top-side {
    display: flex;
    flex-direction: row;
    align-content: space-evenly;
    justify-content: space-between;
    width: 100%;

    img.logo {
      width: 180px;
    }

    .header-info {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-end;

      .top {
        font-size: 11px;
        color: var(--blue70);
        font-weight: 700;
        margin-bottom: 5px;
      }

      .bottom {
        font-size: 11px;
        color: var(--blue70);
        font-weight: 700;
      }

      .key {

      }

      .value {

      }
    }
  }

  .bottom-side {
    font-size: 17px;
    line-height: 39px;
    border-top: 2px solid;
    border-bottom: 1px solid var(--blue70);
    letter-spacing: 3px;
    color: var(--blue70);
    font-weight: 700;
  }
}

.footer {
  height: 45px;
  position: fixed;
  bottom: 0;
  width: calc(100vw - 50px);
  background: #fff;
  border-left: 1px solid var(--white);
  border-right: 1px solid var(--white);
  padding-bottom: 10px;

  div {
    display: flex;
    justify-content: center;
  }
}

.t-foot {
  height: 35px;
  background: #fff;
}

.t-head {
  height: 85px;
  background: #fff;
  margin-bottom: 10px;
}

.content {
  .sub_header {
    font-size: 12px;
    color: rgb(39, 92, 187);
    font-weight: 700;
    letter-spacing: 2px;
    margin-bottom: 7px;
  }

  .report_row {
    margin: 0px 0px 15px;
  }

  .report_common_table {
    .table-container {
      grid-template-rows: repeat(4, 60px);
      grid-template-columns: 1fr 1fr 1fr 1fr;

      .item-parent {
        flex-direction: column;
        align-items: baseline;
        margin: 0.2rem 0;
        border-bottom: 1px solid var(--grey20);

        .item-title {
          font-size: 10px;
          color: #202020;
          font-weight: 700;
        }

        .item-value {
          color: #202020;
          font-size: 12px;
        }
      }
    }
  }

  .basic_info {
    .table-container {
      .item-parent:nth-child(7) {
        grid-column: 3 / 5;
      }

      .item-parent:nth-child(8) {
        grid-column: 1 / 3;
      }

      .item-parent:nth-child(9) {
        grid-column: 3 / 5;
      }

      .item-parent:last-child {
        grid-column: 1 / 5;
      }
    }

  }

  .list {
    display: table;
    width: 100%;

    & ul {
      display: table-row;

      &:first-child {
        & li {
          background-color: #bbbbbb;
          font-size: 10px;
          font-weight: 700;
        }
      }

      &:last-child {
        & > li {
          background: #bbbbbb;
        }
      }

      &:nth-child(odd) {
        background-color: #ebebeb;
      }

      &:nth-child(even) {
        background-color: #fff;
      }

      & > li {
        display: table-cell;
        padding: 0.5em 1em;
        font-size: 11px;
        color: #000;
        border-right: 1px solid #8c8c8c;
        border-left: 1px solid #8c8c8c;
      }

      li {
        &:nth-child(1) {
          text-align: center;
          width: 16%;
        }

        &:nth-child(2) {
          width: 15%;
        }

        &:nth-child(3) {
          width: 15%;
        }

        &:nth-child(4) {
          width: 29%;
        }

        &:nth-child(5) {
          width: 20%;
        }
      }
    }
  }

  .rehab_table {
    .list {
      div {
        width: 100%;
        display: table;
      }

      ul:nth-child(even) > li {
        border-bottom: 1px solid #e8e8e8;
        padding-bottom: 5px;
      }

      ul {
        height: 25px;

        li {
          text-align: left;
          background-color: #fff;
          border-right: 0px;
          border-left: 0px;
          padding-left: 0;
        }

        li:nth-child(1) {
          width: 25%;
        }

        li:nth-child(2) {
          width: 25%;
        }

        li:nth-child(3) {
          width: 25%;
        }

        li:nth-child(4) {
          width: 25%;
        }
      }

      .th {
        height: 20px;

        li {
          font-size: 10px;
          font-weight: 700;
        }
      }
    }
  }

  .text_area {
    border-radius: 10px;
    border: 1px solid #cacaca;
    padding: 15px;
    line-height: 1.5;
    color: #000;
    word-break: break-word;
  }
}

.print_btn {
  position: fixed;
  right: 20px;
  width: 40px;
  background: rgb(236, 78, 58);
  bottom: 20px;
  border-radius: 25px;
  height: 40px;
  transition: 0.3s;
  box-shadow: 4px 4px 5px #cecece, -3px -3px 8px #c8c8c8;

  &:hover {
    bottom: 25px;
  }
}


.rom_graph_for_print {
  display: none;
}

@media only print {
  .print_btn {
    display: none;
  }

  .rom_graph_for_print {
    //프린트시 나오는 그래프 영역 <img>태그로 만들어져 있음. 위치는 ./romChangeSection/blindIcon.vue 에 위치하고있음.
    display: block;
    width: 100%;
    height: auto;
  }
  .rom_graph_for_browser {
    display: none;
  }
  .page {
    page-break-inside: avoid;
  }
  body {
    border: 0;
    margin: 0;

    thead {
      display: table-header-group;
    }

    tfoot {
      display: table-footer-group;
    }

    & > .report_modal_body {
      padding: 0;

      .header {
        width: 100vw;
        padding-top: 0;
        z-index: 1;
      }

      .footer {
        width: 100vw;
        padding-bottom: 0px;
      }

      & > .content {
        overflow: unset;
        height: calc(var(--app-height) - 160px);
        margin-top: 100px;
        padding: 1rem 1rem 0px;
      }
    }
  }
}

;
@media print and (color) {
  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
</style>